import cx from "classnames";
import React, { ReactNode } from "react";

import { Text } from "@/components/elements/Text";
import { NotificationBanner } from "@/components/NotificationBanner";

import styles from "./styles.module.css";

export type SubcategoriesPageProps = {
  title?: string;
  subTitle?: string;
  blurb?: string;
  className?: string;
  displayBanner?: boolean;
  children: ReactNode;
};

export const SubcategoriesPage = ({
  title,
  subTitle,
  blurb,
  className,
  displayBanner,
  children,
}: SubcategoriesPageProps) => {
  return (
    <>
      <div className={cx(styles.container, className)}>
        {title ? (
          <Text as="h1" size="xl" responsive className={styles.title}>
            {title}
          </Text>
        ) : null}
        {subTitle ? (
          <Text as="h2" size="l" responsive className={styles.title}>
            {subTitle}
          </Text>
        ) : null}
        {blurb ? (
          <Text as="p" size="m-20" responsive className={styles.blurb}>
            {blurb}
          </Text>
        ) : null}
        {children}
      </div>
      <NotificationBanner breakout display={displayBanner} />
    </>
  );
};

export default SubcategoriesPage;
